import React, { useState } from 'react';
import {
  MenuItem,
  Box,
  Typography,
  FormControl,
  SelectChangeEvent,
  Select,
  InputLabel,
  Button,
  Paper,
  Grid,
} from '@mui/material';
import { liveArtistsState } from '../../state/RecoilState';
import { useRecoilValue } from 'recoil';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { Artist, ArtistSummaryListItem } from '../../@types/api';
import LocalisedDatePicker from '../../components/Common/LocalisedDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import RestUtilities from '../../services/RestUtilities';
import { colDateFormat, dbDayFormat } from '../../Constants';
import { useGetLiveArtists } from '../../hooks/useGetLiveArtists';

const formControlSxProps = { mx: 1, minWidth: '210px' };
const ArtistTurnover = () => {
  const artists = useRecoilValue(liveArtistsState);
  const [artistId, setArtistId] = useState<number>(-1);
  const [startDate, setStartDate] = useState<Dayjs | null>(
    dayjs().startOf('year')
  );
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs().endOf('year'));
  const [data, setData] = useState<ArtistSummaryListItem[]>([]);

  useGetLiveArtists();

  const handleArtistChange = (event: SelectChangeEvent<unknown>) => {
    setArtistId(Number(event.target.value));
  };

  const handleFetchData = async () => {
    var res = await RestUtilities.get(
      `/api/booking/GetArtistSummaryData?artistId=${artistId}&dateFrom=${startDate?.format(
        dbDayFormat
      )}&dateTo=${endDate?.format(dbDayFormat)}`
    );
    if (res.ok) {
      setData(res.content);
    }
  };

  const handleSendEmail = async () => {
    var res = await RestUtilities.get(
      `/api/booking/EmailArtistSummary?artistId=${artistId}&dateFrom=${startDate?.format(
        dbDayFormat
      )}&dateTo=${endDate?.format(dbDayFormat)}`
    );
    if (res.ok) {
    }
  };

  return (
    <Box>
      <Box my={1} display='flex' justifyContent={'flex-start'}>
        <Typography variant='h5'>Artist Summary</Typography>
        <Box sx={{ ml: 2 }} display={'flex'}>
          <FormControl size='small' sx={formControlSxProps}>
            <InputLabel id='artist-select-label'>Artist</InputLabel>
            <Select
              labelId='artist-select-label'
              id='artist-select'
              label='Artist'
              value={artistId}
              onChange={handleArtistChange}
              variant='outlined'
              size='small'
            >
              <MenuItem value={-1}>-- Select --</MenuItem>
              {artists.map((a: Artist) => (
                <MenuItem value={a.artistId} key={a.artistId}>
                  {a.artistName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size='small' sx={formControlSxProps}>
            <LocalisedDatePicker
              label='StartDate'
              date={startDate}
              setDate={setStartDate}
            />
          </FormControl>
          <FormControl size='small' sx={formControlSxProps}>
            <LocalisedDatePicker
              label='EndDate'
              date={endDate}
              setDate={setEndDate}
            />
          </FormControl>
          <Button
            size='small'
            color='primary'
            variant='contained'
            onClick={handleFetchData}
            sx={{ mr: 1 }}
          >
            Show Data
          </Button>
          <Button
            size='small'
            color='secondary'
            variant='contained'
            onClick={handleSendEmail}
            sx={{ mr: 1 }}
          >
            Email Band
          </Button>
        </Box>
      </Box>
      <Paper sx={{ p: 1, mb: 2 }}>
        <Typography component='h2' variant='h6' color={'primary'} gutterBottom>
          Totals
        </Typography>
        <Grid container>
          <Grid item sx={{ ml: 0 }}>
            Bookings: {data.length}
          </Grid>
        </Grid>
      </Paper>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', minHeight: 200, mb: 2 }}
      >
        <DataGrid
          rows={data}
          getRowId={(row) => row.bookingId}
          slots={{ toolbar: GridToolbar }}
          columns={
            [
              { headerName: 'ID', field: 'bookingId', width: 60 },
              {
                headerName: 'EventDate',
                field: 'eventDate',
                width: 100,
                valueGetter: (params) =>
                  dayjs(params.value).format(colDateFormat),
              },
              { headerName: 'Venue', field: 'venueName', width: 400 },
              { headerName: 'Location', field: 'location', width: 300 },
              { headerName: 'Fee', field: 'bandFee', width: 100 },
            ] as GridColDef[]
          }
          density='compact'
          pageSizeOptions={[25, 50, 100, 250]}
        />
      </Box>
    </Box>
  );
};
export default ArtistTurnover;
